import angular from 'angular';
import uiRouter from 'angular-ui-router';
import queriesComponent from './queries.component';

let queriesModule = angular.module('queries', [
  uiRouter
])

.component('queries', queriesComponent);

export default queriesModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/queries/queries.js